import { motion } from 'framer-motion';
import { Player } from '@/lib/gameStore';
import { getStressEmoji } from '@/lib/gameUtils';

interface PlayerAvatarProps {
  player: Player;
  size?: 'sm' | 'md' | 'lg';
  showStress?: boolean;
}

const sizeClasses = {
  sm: 'w-12 h-12 text-lg',
  md: 'w-16 h-16 text-2xl',
  lg: 'w-20 h-20 text-3xl',
};

const colors = [
  'bg-primary',
  'bg-chaos-purple',
  'bg-chaos-orange',
  'bg-chaos-yellow',
  'bg-chaos-red',
  'bg-accent',
];

export default function PlayerAvatar({ player, size = 'md', showStress = false }: PlayerAvatarProps) {
  const colorIndex = player.id.charCodeAt(0) % colors.length;
  const initial = player.name[0]?.toUpperCase() || '?';

  return (
    <motion.div
      className="relative"
      whileHover={{ scale: 1.05 }}
      animate={player.isActive ? { opacity: 1 } : { opacity: 0.5 }}
    >
      <div
        className={`
          ${sizeClasses[size]} 
          ${colors[colorIndex]}
          rounded-full flex items-center justify-center
          font-black text-white shadow-lg
        `}
      >
        {initial}
      </div>
      
      {showStress && (
        <motion.div
          className="absolute -bottom-1 -right-1 text-xl"
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 1, repeat: Infinity }}
        >
          {getStressEmoji(player.stressLevel)}
        </motion.div>
      )}
    </motion.div>
  );
}
